import { render, staticRenderFns } from "./sensorsidebar.vue?vue&type=template&id=0038bcc6&scoped=true&"
import script from "./sensorsidebar.vue?vue&type=script&lang=js&"
export * from "./sensorsidebar.vue?vue&type=script&lang=js&"
import style0 from "./sensorsidebar.vue?vue&type=style&index=0&id=0038bcc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0038bcc6",
  null
  
)

export default component.exports